import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useState,
  useEffect,
} from 'react';
import styles from './Tabs.module.scss';

type TabContextValue = {
  activeTab: string;
  changeTab: Dispatch<SetStateAction<string>>;
};

const tabCtxInitialValue = {
  activeTab: 'description',
  changeTab: () => {},
};

export const TabContext = createContext<TabContextValue>(tabCtxInitialValue);

export function Tabs(props: {
  initialValue: string;
  resetValue?: boolean;
  tabsTop: React.ReactNode;
  tabsContent: React.ReactNode;
}) {
  const { initialValue, tabsTop, tabsContent, resetValue } = props;

  useEffect(() => {
    resetValue && changeTab(initialValue);
    return;
  }, [resetValue]);

  const [activeTab, changeTab] = useState<string>(initialValue);
  const tabProviderValue = { activeTab, changeTab };

  return (
    <TabContext.Provider value={tabProviderValue}>
      <div className={styles.tabsTop}>{tabsTop}</div>
      <div className={styles.tabsContent}>{tabsContent}</div>
    </TabContext.Provider>
  );
}
